<template>
  <v-dialog width="unset" persistent v-model="visibleModel"  @keydown.esc="close(false)">
    <v-card>
      <v-card-title>
        提交报价
      </v-card-title>
      <v-card-subtitle>
        提交 {{filters.provider}} - {{filters.channel}} ({{filters.quoteDate}}) 的报价
      </v-card-subtitle>
      <v-card-text>
        <v-container class="text-center" v-if="loading">
          <v-progress-circular indeterminate color="primary"/>
        </v-container>
        <v-form v-else ref="form">
          <v-container fluid>
            <v-row align="center" v-for="item in items" :key="item.id">
              <v-col cols="8">
                {{item.channel.channelType}} - {{item.channel.repository}} {{item.minLimit}}-{{item.maxLimit}}{{item.priceType === 1 ? "KG":"CBM"}}
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="item.price" :suffix="'元 (' + item.quoteDate + ')'"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text color="grey" @click="close(false)">关闭</v-btn>
        <v-btn text color="primary" @click="save">保存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "QuotationDialog",
  model: {
    prop: "visible",
    event: "update"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    filters: Object
  },
  computed: {
    visibleModel: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  },
  data() {
    return {
      loading: true,
      items: []
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.items = []
      let params = {}


      params.provider = this.filters.provider
      params.channel = this.filters.channel
      params.quoteDate = this.filters.quoteDate

      if (this.filters.country) {
        params.country = this.filters.country
      }

      if (this.filters.channelType) {
        params.channelType = this.filters.channelType
      }

      if (this.filters.repository) {
        params.repository = this.filters.repository
      }

      this.$axios.get('/quotation/newest', {params}).then(
          res => {
            this.loading = false
            this.items = res.data
          }
      )
    },
    close(flag) {
      this.visibleModel = false

      if (flag) {
        this.$emit('reload')
      }
    },
    save() {
      let params = {}
      params.provider = this.filters.provider
      params.channel = this.filters.channel
      params.quoteDate = this.filters.quoteDate
      params.quotations = this.items

      if (this.filters.country) {
        params.country = this.filters.country
      }

      if (this.filters.channelType) {
        params.channelType = this.filters.channelType
      }

      if (this.filters.repository) {
        params.repository = this.filters.repository
      }

      this.$axios.patch("/quotations", params).then(
          () => {
            this.close(true)
          }
      )
    },
  },
  watch: {
    visibleModel() {
      if (this.visibleModel) {
        this.getData()
      }
    }
  }
}
</script>

<style scoped>

</style>